// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs-container {
  position: relative;
  max-height: 1lh;
}

.breadcrumbs-inner-container {
  max-height: 2lh;
}

.breadcrumbs-inner-measurement {
  height: 0;
  opacity: 0;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
